/* Elaré reviews: pulls live reviews from Judge.me's public feeds and renders our own cards. */
(function(){
  if (window.__elareReviews) return; window.__elareReviews = true;
  var API = 'https://api.judge.me/reviews/', CDN = 'https://cdn.judge.me/reviews/';
  var MIN = 3; /* reviews below this star rating are never shown */

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function cap(s){ s = String(s || '').toLowerCase().trim(); return s.charAt(0).toUpperCase() + s.slice(1); }
  function prodName(t){
    if (!t) return '';
    var p = String(t).split(/\s+[—–-]\s+/); var base = cap(p[0]);
    return p.length > 1 ? base + ', ' + p[p.length - 1].toLowerCase() : base;
  }
  function name(n){
    n = String(n || '').trim(); if (!n) return 'Customer';
    var w = n.split(/\s+/);
    if (w.length > 1) return cap(w[0]) + ' ' + w[w.length - 1].charAt(0).toUpperCase() + '.';
    return n.charAt(0).toUpperCase() + n.slice(1);
  }
  function date(d){
    if (!d) return '';
    var t = new Date(String(d).replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(t)) return '';
    return t.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  function text(html){ var d = document.createElement('div'); d.innerHTML = html || ''; return (d.textContent || '').replace(/\s+\n/g, '\n').trim(); }

  /* normalise JSON reviews (carousel + product feeds) */
  function fromJson(r){
    return {
      id: r.uuid, rating: +r.rating || 0, title: r.title || '', body: r.body || text(r.body_html),
      name: r.is_anonymous_reviewer ? 'Customer' : r.reviewer_name, date: r.created_at, verified: !!r.verified_buyer,
      pics: (r.pictures_urls || []).map(function(p){ return { s: p.compact || p.small || p.original, l: p.huge || p.original }; }),
      product: r.product_title || '', url: r.product_url || ''
    };
  }
  /* parse Judge.me's all-reviews html into the same shape */
  function fromHtml(html){
    var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    return Array.prototype.map.call(doc.querySelectorAll('.jdgm-rev'), function(el){
      var q = function(s){ return el.querySelector(s); };
      var sc = q('.jdgm-rev__rating'), ts = q('.jdgm-rev__timestamp'), pl = q('.jdgm-rev__prod-link');
      return {
        id: el.getAttribute('data-review-id'), rating: sc ? +sc.getAttribute('data-score') : 0,
        title: q('.jdgm-rev__title') ? q('.jdgm-rev__title').textContent.trim() : '',
        body: q('.jdgm-rev__body') ? text(q('.jdgm-rev__body').innerHTML) : '',
        name: q('.jdgm-rev__author') ? q('.jdgm-rev__author').textContent.trim() : '',
        date: ts ? ts.getAttribute('data-content') : '', verified: el.getAttribute('data-verified-buyer') === 'true',
        pics: Array.prototype.map.call(el.querySelectorAll('.jdgm-rev__pic-link'), function(a){
          var img = a.querySelector('img'); var l = a.getAttribute('data-mfp-src') || a.getAttribute('href');
          return { s: (img && (img.getAttribute('data-src') || img.getAttribute('src'))) || l, l: l };
        }),
        product: pl ? pl.textContent.trim() : '', url: pl ? pl.getAttribute('href') : ''
      };
    });
  }

  function stars(r){ return '<span class="rv-stars" style="--r:' + r + '" role="img" aria-label="' + r + ' out of 5 stars"></span>'; }

  function card(r, root, showProduct){
    if (root.hasAttribute('data-nopics')) r.pics = [];
    var pic = r.pics[0];
    var body = r.body || '';
    var long = body.length > 220;
    var h = '<article class="rv' + (pic ? ' rv--pic' : '') + '">';
    if (pic) h += '<button type="button" class="rv__pic" data-rv-zoom="' + esc(pic.l) + '" aria-label="View photo"><img src="' + esc(pic.s.replace(/width=\d+/, 'width=640')) + '" alt="Customer photo" loading="lazy"></button>';
    h += '<div class="rv__in">' + stars(r.rating);
    if (r.title) h += '<h3 class="rv__title">' + esc(r.title) + '</h3>';
    if (body) h += '<p class="rv__body' + (long ? ' is-clamp' : '') + '">' + esc(body) + '</p>' + (long ? '<button type="button" class="rv__more u" data-rv-more>' + esc(root.dataset.lMore) + '</button>' : '');
    if (r.pics.length > 1) {
      h += '<div class="rv__thumbs">';
      r.pics.slice(1, 5).forEach(function(p){ h += '<button type="button" data-rv-zoom="' + esc(p.l) + '" aria-label="View photo"><img src="' + esc(p.s) + '" alt="" loading="lazy"></button>'; });
      h += '</div>';
    }
    h += '<div class="rv__meta"><span class="rv__name">' + esc(name(r.name)) + '</span>';
    if (r.verified) h += '<span class="rv__ver">' + esc(root.dataset.lVerified) + '</span>';
    h += '<span class="rv__date">' + esc(date(r.date)) + '</span></div>';
    if (showProduct && r.product) h += '<a class="rv__prod" href="' + esc(r.url || '#') + '">' + esc(prodName(r.product)) + '</a>';
    h += '</div></article>';
    return h;
  }

  function get(url){ return fetch(url, { credentials: 'omit' }).then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); }); }

  function init(root){
    if (root.__rv) return; root.__rv = true;
    var mode = root.dataset.mode, shop = root.dataset.shop, list = root.querySelector('[data-rv-list]');
    var loadBtn = root.querySelector('[data-rv-load]'), per = +root.dataset.per || 12, page = 0, seen = {}, first = true;
    var base = 'shop_domain=' + encodeURIComponent(shop) + '&platform=shopify';

    function put(reviews, showProduct){
      if (first) { list.innerHTML = ''; first = false; }
      var h = '', n = 0;
      reviews.forEach(function(r){ if (r.rating < MIN) return; if (r.id && seen[r.id]) return; seen[r.id] = 1; n++; h += card(r, root, showProduct); });
      list.insertAdjacentHTML('beforeend', h);
      return n;
    }
    function none(){ if (!list.children.length) root.classList.add('rvs--none'); }
    function fail(){ if (first) { list.innerHTML = ''; root.classList.add('rvs--none'); } if (loadBtn) loadBtn.hidden = true; }

    function next(){
      page++;
      if (loadBtn) { loadBtn.disabled = true; }
      var p;
      if (mode === 'carousel') {
        p = get(CDN + 'reviews_for_carousel?reviews_selection=all&carousel_type=cards&star_rating=' + (root.dataset.stars || '5_star') +
          '&max_reviews=' + (root.dataset.max || 20) + '&display_order=media_first&url=' + encodeURIComponent(root.dataset.origin || location.origin) + '&' + base)
          .then(function(d){ put((d.reviews || []).map(fromJson), true); none(); });
      } else if (mode === 'product') {
        p = get(API + 'reviews_for_widget?url=' + encodeURIComponent(shop) + '&' + base + '&page=' + page + '&per_page=' + per + '&product_id=' + root.dataset.product)
          .then(function(d){
            var n = put((d.reviews || []).map(fromJson), false);
            var tp = (d.pagination && d.pagination.total_pages) || 0;
            if (n < 1 && page < tp) return next();
            if (loadBtn) loadBtn.hidden = page >= tp;
            var e = root.querySelector('[data-rv-empty]'); if (e) e.hidden = list.children.length > 0;
            if (!e) none();
          });
      } else {
        p = get(API + 'all_reviews_js_based?url=' + encodeURIComponent(shop) + '&' + base + '&page=' + page + '&per_page=' + per)
          .then(function(d){
            var rs = fromHtml(d.html || '');
            var n = put(rs, true);
            if (n < 1 && rs.length >= per) return next();
            if (loadBtn) loadBtn.hidden = rs.length < per;
            none();
          });
      }
      return p.catch(fail).then(function(){ if (loadBtn) loadBtn.disabled = false; });
    }

    if (loadBtn) loadBtn.addEventListener('click', next);

    root.addEventListener('click', function(e){
      var m = e.target.closest('[data-rv-more]');
      if (m) { var b = m.previousElementSibling; var open = b.classList.toggle('is-clamp'); m.textContent = open ? root.dataset.lMore : root.dataset.lLess; return; }
      var z = e.target.closest('[data-rv-zoom]');
      if (z) { zoom(z.getAttribute('data-rv-zoom')); return; }
      var a = e.target.closest('[data-rv-prev],[data-rv-next]');
      if (a) { var w = list.clientWidth * 0.9; list.scrollBy({ left: a.hasAttribute('data-rv-prev') ? -w : w, behavior: 'smooth' }); }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(en){ if (en[0].isIntersecting) { io.disconnect(); next(); } }, { rootMargin: '600px' });
      io.observe(root);
    } else next();
  }

  var box;
  function zoom(src){
    if (!box) {
      box = document.createElement('div'); box.className = 'rv-zoom'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Customer photo');
      box.innerHTML = '<button type="button" class="rv-zoom__x" aria-label="Close">&times;</button><img alt="Customer photo">';
      box.addEventListener('click', function(e){ if (e.target === box || e.target.closest('.rv-zoom__x')) close(); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && box.classList.contains('on')) close(); });
      document.body.appendChild(box);
    }
    box.querySelector('img').src = src; box.classList.add('on'); document.documentElement.style.overflow = 'hidden'; box.querySelector('.rv-zoom__x').focus();
  }
  function close(){ box.classList.remove('on'); document.documentElement.style.overflow = ''; }

  function boot(){ document.querySelectorAll('[data-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
